// import React, { useMemo, useRef, useState, useEffect } from "react";
// import { FleetrifyModal } from "../../../Modal/modal";
// import { fleetrifyIcons } from "../../../../assets/icons/icons";
// import { FleetrifyInputField } from "../../../Input/input";
// import { FleetrifyButton } from "../../../Button/customButton";
// import { FleetrifyTextareaField } from "../../../Input/textArea";
// import {
//   useGetAllServiceTypesQuery,
//   useCreateServiceMutation,
// } from "../../../../redux/services/serviceApi";
// import { toast } from "sonner";
// import { useStaffController } from "../../../../controllers/useStaffController";
// import { useGetCompanyInfoQuery } from "../../../../redux/services/settingsApi";
// import { usePermission } from "../../../../hooks/usePermission";
// import { ChevronDown, X, Check } from "lucide-react";

// // ─────────────────────────────────────────────
// // InlineSelect — dropdown stays inside DOM tree
// // so modal's outside-click never fires
// // ─────────────────────────────────────────────
// const InlineSelect = ({
//   value,
//   options,
//   onChange,
//   placeholder = "Select...",
//   disabled = false,
// }: {
//   value: string;
//   options: { label: string; value: string }[];
//   onChange: (val: string) => void;
//   placeholder?: string;
//   disabled?: boolean;
// }) => {
//   const [open, setOpen] = useState(false);
//   const wrapRef = useRef<HTMLDivElement>(null);
//   const selected = options.find((o) => o.value === value);

//   // Close on outside click within the page
//   useEffect(() => {
//     if (!open) return;
//     const handler = (e: MouseEvent) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, [open]);

//   return (
//     <div ref={wrapRef} className="relative w-full" style={{ zIndex: open ? 50 : "auto" }}>
//       <button
//         type="button"
//         disabled={disabled}
//         onClick={() => !disabled && setOpen((p) => !p)}
//         className={`w-full flex items-center justify-between gap-2 px-4 py-3 text-sm border rounded-md bg-white transition-colors duration-200
//           ${disabled ? "cursor-not-allowed border-gray-200 bg-gray-50 text-gray-400" : "border-gray-300 hover:border-[#143887] cursor-pointer"}
//           ${open ? "border-[#143887] ring-[0.5px] ring-[#143887]" : ""}
//         `}
//       >
//         <span className={selected ? "text-[#00032A]" : "text-gray-400 text-xs"}>
//           {disabled && !selected ? "Loading..." : (selected?.label ?? placeholder)}
//         </span>
//         <ChevronDown size={14} className={`text-gray-400 flex-shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
//       </button>

//       {open && (
//         <div
//           className="absolute left-0 top-full mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg overflow-y-auto"
//           style={{ zIndex: 9999, maxHeight: 200 }}
//         >
//           {options.length === 0 ? (
//             <div className="px-4 py-3 text-sm text-gray-400">No options available</div>
//           ) : options.map((opt) => (
//             <button
//               key={opt.value}
//               type="button"
//               onClick={() => { onChange(opt.value); setOpen(false); }}
//               className={`w-full text-left px-4 py-2.5 text-sm flex items-center justify-between hover:bg-[#e4ebf8] hover:text-[#143887] transition-colors
//                 ${opt.value === value ? "bg-[#e4ebf8] text-[#143887] font-medium" : "text-[#00032A]"}
//               `}
//             >
//               {opt.label}
//               {opt.value === value && <Check size={13} className="text-[#143887] flex-shrink-0" />}
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// // ─────────────────────────────────────────────
// // InlineMultiSelect
// // ─────────────────────────────────────────────
// const InlineMultiSelect = ({
//   value,
//   options,
//   onChange,
//   placeholder = "Select options...",
// }: {
//   value: string[];
//   options: { label: string; value: string }[];
//   onChange: (vals: string[]) => void;
//   placeholder?: string;
// }) => {
//   const [open, setOpen] = useState(false);
//   const wrapRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     if (!open) return;
//     const handler = (e: MouseEvent) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, [open]);

//   const toggle = (val: string) =>
//     onChange(value.includes(val) ? value.filter((v) => v !== val) : [...value, val]);

//   const remove = (val: string, e: React.MouseEvent) => {
//     e.stopPropagation();
//     onChange(value.filter((v) => v !== val));
//   };

//   const getLabel = (val: string) => options.find((o) => o.value === val)?.label ?? val;

//   return (
//     <div ref={wrapRef} className="relative w-full" style={{ zIndex: open ? 50 : "auto" }}>
//       <div
//         onClick={() => setOpen((p) => !p)}
//         className={`w-full min-h-[46px] flex flex-wrap items-center gap-1.5 px-4 py-2 border rounded-md bg-[#FAFAFA] cursor-pointer transition-colors duration-200
//           ${open ? "border-[#143887] ring-[0.5px] ring-[#143887]" : "border-gray-300 hover:border-[#143887]"}
//         `}
//       >
//         {value.length === 0 ? (
//           <span className="text-xs text-gray-400">{placeholder}</span>
//         ) : (
//           value.map((val) => (
//             <span
//               key={val}
//               className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#e4ebf8] text-[#143887] text-xs font-medium border border-[#c5d5ef]"
//             >
//               {getLabel(val)}
//               <button
//                 type="button"
//                 onClick={(e) => remove(val, e)}
//                 className="hover:text-red-500 transition-colors ml-0.5"
//               >
//                 <X size={10} />
//               </button>
//             </span>
//           ))
//         )}
//         <ChevronDown
//           size={14}
//           className={`text-gray-400 ml-auto flex-shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
//         />
//       </div>

//       {open && (
//         <div
//           className="absolute left-0 top-full mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg overflow-y-auto"
//           style={{ zIndex: 9999, maxHeight: 200 }}
//         >
//           {options.length === 0 ? (
//             <div className="px-4 py-3 text-sm text-gray-400">No options available</div>
//           ) : options.map((opt) => {
//             const sel = value.includes(opt.value);
//             return (
//               <button
//                 key={opt.value}
//                 type="button"
//                 onClick={() => toggle(opt.value)}
//                 className={`w-full text-left px-4 py-2.5 text-sm flex items-center gap-2.5 hover:bg-[#e4ebf8] transition-colors
//                   ${sel ? "text-[#143887] font-medium" : "text-[#00032A]"}
//                 `}
//               >
//                 <span className={`w-4 h-4 rounded border flex-shrink-0 flex items-center justify-center transition-colors
//                   ${sel ? "bg-[#143887] border-[#143887]" : "border-gray-300 bg-white"}
//                 `}>
//                   {sel && (
//                     <svg viewBox="0 0 10 10" className="w-2.5 h-2.5 text-white" fill="none">
//                       <path d="M1.5 5l2.5 2.5 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
//                     </svg>
//                   )}
//                 </span>
//                 {opt.label}
//               </button>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// // ═════════════════════════════════════════════
// // Main Component
// // ═════════════════════════════════════════════
// interface AddServiceModalProps {
//   isModalOpen: boolean;
//   setIsModalOpen: (param: boolean) => void;
//   onSuccess?: () => void;
// }

// const AddServiceModal: React.FC<AddServiceModalProps> = ({
//   isModalOpen,
//   setIsModalOpen,
//   onSuccess,
// }) => {
//   const [form, setForm] = useState({
//     service_category: "",
//     description: "",
//     from: "",
//     to: "",
//     price_model: "",
//     vehicle_types: [] as string[],
//     price: "",
//     staff_members: [] as string[],
//   });

//   const { data: companyInfoData } = useGetCompanyInfoQuery();
//   const companyId = companyInfoData?.data?.companyInfo?.id;

//   const { staffData } = useStaffController();
//   const staffOptions = useMemo(() =>
//     staffData?.map((staff: any) => ({
//       label: `${staff.firstName} ${staff.lastName}`,
//       value: staff.id,
//     })) || [],
//     [staffData]
//   );

//   const { service_category, description, from, to, price_model, vehicle_types, price, staff_members } = form;

//   const {
//     data: serviceTypes,
//     isLoading: loadingServiceTypes,
//     isFetching: fetchingServiceTypes,
//   } = useGetAllServiceTypesQuery(undefined, { skip: !isModalOpen });

//   const isDynamicPricing = serviceTypes?.find((type) => type.name === "Day-to-Day Delivery")?.id;

//   const [createService, { isLoading: creatingService }] = useCreateServiceMutation();
//   const { hasPermission } = usePermission();

//   const serviceCategoryOptions = useMemo(() =>
//     serviceTypes?.map((type) => ({ label: type.name, value: type.id })) || [],
//     [serviceTypes]
//   );

//   const selectedCategoryName =
//     serviceCategoryOptions.find((o) => o.value === service_category)?.label ?? "";

//   // const priceModelOptions = [
//   //   { label: "Per KM", value: "per_km" },
//   //   { label: "Fixed", value: "fixed" },
//   //   { label: "Fixed Per KM", value: "fixed_per_km" },
//   //   { label: "Subscription", value: "subscription" },
//   // ];

//   const vehicleTypeOptions = [
//     { label: "Car", value: "car" },
//     { label: "Truck", value: "truck" },
//     { label: "Bike", value: "bike" },
//     { label: "Van", value: "van" },
//     // { label: "Trailer", value: "trailer" },
//     // { label: "Ship", value: "ship" },
//     // { label: "Tricycle", value: "tricycle" },
//   ];

//   const handleChange = (key: string, value: any) =>
//     setForm((prev) => ({ ...prev, [key]: value }));

//   const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) =>
//     handleChange("price", e.target.value.replace(/[^0-9.]/g, ""));

//   useEffect(() => {
//     if (!service_category) {
//       handleChange("price_model", "");
//       return;
//     }

//     const derivedModel = service_category === isDynamicPricing ? "dynamic" : "fixed";
//     handleChange("price_model", derivedModel);
//   }, [service_category, isDynamicPricing]);

//   const resetForm = () =>
//     setForm({ service_category: "", description: "", from: "", to: "", price_model: "", vehicle_types: [], price: "", staff_members: [] });

//   const onSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!hasPermission("add services")) { toast.error("You don't have permission to create a service"); return; }
//     if (!service_category) { toast.error("Please select a service category"); return; }
//     if (!description.trim()) { toast.error("Please enter a description"); return; }
//     if (!price || parseFloat(price) <= 0) { toast.error("Please enter a valid price"); return; }
//     if (vehicle_types.length === 0) { toast.error("Please select at least one vehicle type"); return; }
//     // if (!from.trim()) { toast.error("Please enter the starting location (From)"); return; }
//     // if (!to.trim()) { toast.error("Please enter the destination location (To)"); return; }
//     // if (!price_model) { toast.error("Please select a price model"); return; }

//     try {
//       const payload: any = {
//         description,
//         base_price: service_category === isDynamicPricing ? price : 0,
//         price: service_category === isDynamicPricing ? 0 : price,
//         vehicle_type: vehicle_types.join(", "),
//         price_model,
//         service_type_id: service_category,
//         from: from.trim(),
//         to: to.trim(),
//         company_id: companyId,
//         staff_members_id: staff_members,
//       };

//       await createService(payload).unwrap();
//       toast.success("Service created successfully!");
//       resetForm();
//       setIsModalOpen(false);
//       if (onSuccess) onSuccess();
//     } catch (error: any) {
//       toast.error(error?.data?.message || "Failed to create service");
//       console.error("Create service error:", error);
//     }
//   };

//   const handleClose = () => { resetForm(); setIsModalOpen(false); };

//   return (
//     <FleetrifyModal
//       isOpen={isModalOpen}
//       onClose={handleClose}
//       title="Add Service"
//       className="w-[90%] sm:w-[600px] md:w-[720px] h-auto max-w-full max-h-[90vh] overflow-y-auto"
//       enableOutsideClick={false}
//     >
//       {/* overflow-visible so inline dropdowns aren't clipped */}
//       <div style={{ overflowY: "visible" }}>
//         <form
//           className="flex flex-col px-4 sm:px-8 md:px-12 lg:px-16 py-4"
//           onSubmit={onSubmit}
//           style={{ overflowY: "visible" }}
//         >
//           <div className="flex gap-3 items-center mb-6">
//             <div className="bg-[#14388733] h-[24px] w-[24px] rounded-[3px] grid place-items-center">
//               <figure>{fleetrifyIcons.addNewUserIcon}</figure>
//             </div>
//             <h6 className="text-sm font-bold text-[#00032A]"> wei</h6>
//           </div>

//           {/* Service Name + Service Category */}
//           <div className="flex flex-col md:flex-row md:gap-4 gap-4 w-full mb-4">
//             <div className="flex-1 w-full hidden">
//               <label className="block text-sm font-medium mb-2 text-gray-700">
//                 Service Name <span className="text-red-500">*</span>
//               </label>
//               <div className="w-full px-4 py-3 border border-gray-200 rounded-md bg-gray-50 text-sm min-h-[46px] flex items-center cursor-not-allowed select-none">
//                 {selectedCategoryName
//                   ? <span className="text-[#00032A]">{selectedCategoryName}</span>
//                   : <span className="text-gray-300 text-xs italic">Auto-filled from category</span>
//                 }
//               </div>
//             </div>

//             <div className="flex-1 w-full" style={{ position: "relative", zIndex: 40 }}>
//               <label className="block text-sm font-medium mb-2 text-gray-700">
//                 Service Category <span className="text-red-500">*</span>
//               </label>
//               <InlineSelect
//                 value={service_category}
//                 options={serviceCategoryOptions}
//                 onChange={(val) => handleChange("service_category", val)}
//                 placeholder={loadingServiceTypes || fetchingServiceTypes ? "Loading..." : "Select service category"}
//                 disabled={loadingServiceTypes || fetchingServiceTypes}
//               />
//             </div>
//           </div>

//           {/* Description */}
//           <div className="w-full mb-4">
//             <FleetrifyTextareaField
//               label="Description"
//               id="description"
//               value={description}
//               onChange={(e) => handleChange("description", e.target.value)}
//               placeholder="Enter service description"
//               required
//               className="w-full"
//               textareaClassName="h-[65px]"
//             />
//           </div>

//           {/* From / To */}
//           {service_category !== isDynamicPricing &&
//           <div className="flex flex-col md:flex-row md:gap-4 gap-4 w-full mb-4">
//             <div className="flex-1 w-full">
//               <FleetrifyInputField
//                 label="From"
//                 id="from"
//                 value={from}
//                 onChange={(e) => handleChange("from", e.target.value)}
//                 placeholder="Enter starting location"
//                 required
//                 className="w-full"
//                 inputClassName="text-xs"
//               />
//             </div>
//             <div className="flex-1 w-full">
//               <FleetrifyInputField
//                 label="To"
//                 id="to"
//                 value={to}
//                 onChange={(e) => handleChange("to", e.target.value)}
//                 placeholder="Enter destination location"
//                 required
//                 className="w-full"
//                 inputClassName="text-xs"
//               />
//             </div>
//           </div>}

//           {/* Price / Price Model */}
//           {/* Price / Price Model */}
//           <div className="flex flex-col md:flex-row md:gap-4 gap-4 w-full mb-4">

//             {/* Price Field */}
//             <div
//               className="flex-1 w-full group"
//             >
//               <label className="block text-sm font-medium mb-2 text-gray-700">
//                 {service_category === isDynamicPricing
//                   ? "Dynamic Pricing (Min: ₦500 - Max: ₦20,000)"
//                   : "Fixed Pricing"}{" "}
//                 <span className="text-red-500">*</span>
//               </label>

//               <div className="relative">
//                 <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-600 font-semibold text-base">
//                   ₦
//                 </span>

//                 <input
//                   type="number"
//                   value={price}
//                   onChange={handlePriceChange}
//                   placeholder="0.00"
//                   max={service_category === isDynamicPricing ? 20000 : undefined}
//                   min={service_category === isDynamicPricing ? 500 : undefined}
//                   required
//                   className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-md bg-[#FAFAFA] text-sm transition-colors duration-200 focus:outline-none focus:ring-[0.5px] focus:ring-[#143887] focus:border-[#143887] hover:border-[#143887]"
//                 />
//               </div>

//               {/* Dynamic pricing helper note */}
//               {service_category === isDynamicPricing && (
//                 <p className="mt-2 text-xs text-[#143887] hidden group-hover:block">
//                   This amount serves as the base price. Final pricing may increase depending
//                   on delivery distance, route conditions, and operational factors.
//                 </p>
//               )}
//             </div>

//             {/* Price Model */}
//             <div
//               className="flex-1 w-full"
//               style={{ position: "relative", zIndex: 35 }}
//             >
//               <label className="block text-sm font-medium mb-2 text-gray-700">
//                 Price Model <span className="text-red-500">*</span>
//               </label>

//               <input
//                 type="text"
//                 value={
//                   service_category === isDynamicPricing
//                     ? "Dynamic"
//                     : "Fixed"
//                 }
//                 readOnly
//                 disabled
//                 required
//                 className="w-full p-4 py-3 border border-gray-300 rounded-md bg-gray-50 text-sm cursor-not-allowed select-none"
//               />
//             </div>
//           </div>

//           {/* Vehicle Types */}
//           <div className="flex flex-col w-full mb-4" style={{ position: "relative", zIndex: 30 }}>
//             <label className="text-sm font-medium mb-2 text-gray-700">
//               Vehicle Types <span className="text-red-500">*</span>
//             </label>
//             <InlineMultiSelect
//               value={vehicle_types}
//               options={vehicleTypeOptions}
//               onChange={(vals) => handleChange("vehicle_types", vals)}
//               placeholder="Select vehicle types"
//             />
//           </div>

//           {/* Staff Members */}
//           <div className="flex flex-col w-full mb-4" style={{ position: "relative", zIndex: 25 }}>
//             <label className="text-sm font-medium mb-2 text-gray-700">
//               Staff Members <span className="text-red-500">*</span>
//             </label>
//             <InlineMultiSelect
//               value={staff_members}
//               options={staffOptions}
//               onChange={(vals) => handleChange("staff_members", vals)}
//               placeholder="Select staff members"
//             />
//           </div>

//           <div className="mt-6">
//             <FleetrifyButton
//               type="submit"
//               className="w-full"
//               disabled={creatingService || !hasPermission("add services")}
//             >
//               {creatingService ? "Creating..." : "Create Service"}
//             </FleetrifyButton>
//           </div>
//         </form>
//       </div>
//     </FleetrifyModal>
//   );
// };

import React, { useMemo, useRef, useState, useEffect } from "react";
import { FleetrifyModal } from "../../../Modal/modal";
import { fleetrifyIcons } from "../../../../assets/icons/icons";
import { FleetrifyButton } from "../../../Button/customButton";
import { FleetrifyTextareaField } from "../../../Input/textArea";
import {
  useGetAllServiceTypesQuery,
  useCreateServiceMutation,
} from "../../../../redux/services/serviceApi";
import { toast } from "sonner";
import { usePlanLimit } from "../../../../hooks/usePlanLimit";
import { DAY_TO_DAY_MIN_BASE_PRICE, DAY_TO_DAY_SERVICE_NAME, dayToDayPriceError, formatNaira } from "../../../../utils/servicePricing";
import { useStaffOptions } from "../../../../hooks/useStaffOptions";
import { useGetCompanyInfoQuery } from "../../../../redux/services/settingsApi";
import { usePermission } from "../../../../hooks/usePermission";
import { ChevronDown, X, Check, Trash2, Plus } from "lucide-react";
import InfoTooltip from "../../../Tooltip/InfoTooltip";

interface RouteRow {
  id: string;
  from: string;
  to: string;
  price: string;
  staff_member_ids: string[];
  vehicle_type: string;
}

const InlineSelect = ({
  value,
  options,
  onChange,
  placeholder = "Select...",
  disabled = false,
}: {
  value: string;
  options: { label: string; value: string }[];
  onChange: (val: string) => void;
  placeholder?: string;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);
  const selected = options.find((o) => o.value === value);

  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div ref={wrapRef} className="relative w-full" style={{ zIndex: open ? 50 : "auto" }}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => !disabled && setOpen((p) => !p)}
        className={`w-full flex items-center justify-between gap-2 px-4 py-3 text-sm border rounded-md bg-white transition-colors duration-200
          ${disabled ? "cursor-not-allowed border-gray-200 bg-gray-50 text-gray-400" : "border-gray-300 hover:border-[#143887] cursor-pointer"}
          ${open ? "border-[#143887] ring-[0.5px] ring-[#143887]" : ""}
        `}
      >
        <span className={selected ? "text-[#00032A]" : "text-gray-400 text-xs"}>
          {disabled && !selected ? "Loading..." : (selected?.label ?? placeholder)}
        </span>
        <ChevronDown size={14} className={`text-gray-400 flex-shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div
          className="absolute left-0 top-full mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg overflow-y-auto"
          style={{ zIndex: 9999, maxHeight: 200 }}
        >
          {options.length === 0 ? (
            <div className="px-4 py-3 text-sm text-gray-400">No options available</div>
          ) : options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => { onChange(opt.value); setOpen(false); }}
              className={`w-full text-left px-4 py-2.5 text-sm flex items-center justify-between hover:bg-[#e4ebf8] hover:text-[#143887] transition-colors
                ${opt.value === value ? "bg-[#e4ebf8] text-[#143887] font-medium" : "text-[#00032A]"}
              `}
            >
              {opt.label}
              {opt.value === value && <Check size={13} className="text-[#143887] flex-shrink-0" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const InlineMultiSelect = ({
  value,
  options,
  onChange,
  placeholder = "Select options...",
}: {
  value: string[];
  options: { label: string; value: string }[];
  onChange: (vals: string[]) => void;
  placeholder?: string;
}) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const toggle = (val: string) =>
    onChange(value.includes(val) ? value.filter((v) => v !== val) : [...value, val]);

  const remove = (val: string, e: React.MouseEvent) => {
    e.stopPropagation();
    onChange(value.filter((v) => v !== val));
  };

  const getLabel = (val: string) => options.find((o) => o.value === val)?.label ?? val;

  return (
    <div ref={wrapRef} className="relative w-full" style={{ zIndex: open ? 50 : "auto" }}>
      <div
        onClick={() => setOpen((p) => !p)}
        className={`w-full min-h-[46px] flex flex-wrap items-center gap-1.5 px-4 py-2 border rounded-md bg-[#FAFAFA] cursor-pointer transition-colors duration-200
          ${open ? "border-[#143887] ring-[0.5px] ring-[#143887]" : "border-gray-300 hover:border-[#143887]"}
        `}
      >
        {value.length === 0 ? (
          <span className="text-xs text-gray-400">{placeholder}</span>
        ) : (
          value.map((val) => (
            <span
              key={val}
              className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#e4ebf8] text-[#143887] text-xs font-medium border border-[#c5d5ef]"
            >
              {getLabel(val)}
              <button
                type="button"
                onClick={(e) => remove(val, e)}
                className="hover:text-red-500 transition-colors ml-0.5"
              >
                <X size={10} />
              </button>
            </span>
          ))
        )}
        <ChevronDown
          size={14}
          className={`text-gray-400 ml-auto flex-shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </div>

      {open && (
        <div
          className="absolute left-0 top-full mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg overflow-y-auto"
          style={{ zIndex: 9999, maxHeight: 200 }}
        >
          {options.length === 0 ? (
            <div className="px-4 py-3 text-sm text-gray-400">No options available</div>
          ) : options.map((opt) => {
            const sel = value.includes(opt.value);
            return (
              <button
                key={opt.value}
                type="button"
                onClick={() => toggle(opt.value)}
                className={`w-full text-left px-4 py-2.5 text-sm flex items-center gap-2.5 hover:bg-[#e4ebf8] transition-colors
                  ${sel ? "text-[#143887] font-medium" : "text-[#00032A]"}
                `}
              >
                <span className={`w-4 h-4 rounded border flex-shrink-0 flex items-center justify-center transition-colors
                  ${sel ? "bg-[#143887] border-[#143887]" : "border-gray-300 bg-white"}
                `}>
                  {sel && (
                    <svg viewBox="0 0 10 10" className="w-2.5 h-2.5 text-white" fill="none">
                      <path d="M1.5 5l2.5 2.5 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </span>
                {opt.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

const RouteRowInput = ({
  row,
  index,
  total,
  onChange,
  onRemove,
  staffOptions,
  vehicleTypeOptions,
}: {
  row: RouteRow;
  index: number;
  total: number;
  onChange: (id: string, field: keyof Omit<RouteRow, "id">, value: string | string[]) => void;
  onRemove: (id: string) => void;
  staffOptions: { label: string; value: string }[];
  vehicleTypeOptions: { label: string; value: string }[];
}) => {
  const handlePriceInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(row.id, "price", e.target.value.replace(/[^0-9.]/g, ""));
  };

  return (
    <div className="relative border border-gray-200 rounded-lg p-4 bg-gray-50 mb-3">
      {/* Row label + remove button */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold text-[#143887] uppercase tracking-wide">
          Route {index + 1}
        </span>
        {total > 1 && (
          <button
            type="button"
            onClick={() => onRemove(row.id)}
            className="flex items-center gap-1 text-xs text-red-500 hover:text-red-700 transition-colors"
          >
            <Trash2 size={13} />
            Remove
          </button>
        )}
      </div>

      {/* From / To */}
      <div className="flex flex-col md:flex-row md:gap-3 gap-3 mb-3">
        <div className="flex-1">
          <label className="block text-xs font-medium mb-1.5 text-gray-600">
            From <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={row.from}
            onChange={(e) => onChange(row.id, "from", e.target.value)}
            placeholder="Enter starting location"
            required
            className="w-full px-4 py-2.5 border border-gray-300 rounded-md bg-white text-sm transition-colors duration-200 focus:outline-none focus:ring-[0.5px] focus:ring-[#143887] focus:border-[#143887] hover:border-[#143887]"
          />
        </div>
        <div className="flex-1">
          <label className="block text-xs font-medium mb-1.5 text-gray-600">
            To <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={row.to}
            onChange={(e) => onChange(row.id, "to", e.target.value)}
            placeholder="Enter destination location"
            required
            className="w-full px-4 py-2.5 border border-gray-300 rounded-md bg-white text-sm transition-colors duration-200 focus:outline-none focus:ring-[0.5px] focus:ring-[#143887] focus:border-[#143887] hover:border-[#143887]"
          />
        </div>
      </div>

      {/* Price */}
      <div>
        <label className="block text-xs font-medium mb-1.5 text-gray-600 flex items-center gap-1.5">
          Fixed Price <span className="text-red-500">*</span>
          <InfoTooltip
            position="bottom"
            iconSize={12}
            text="This price applies only to this From/To route, not the whole service. Different routes under the same service can each have their own price."
          />
        </label>
        <div className="relative">
          <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-600 font-semibold text-sm">
            ₦
          </span>
          <input
            type="number"
            value={row.price}
            onChange={handlePriceInput}
            placeholder="0.00"
            min={0}
            required
            className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-md bg-white text-sm transition-colors duration-200 focus:outline-none focus:ring-[0.5px] focus:ring-[#143887] focus:border-[#143887] hover:border-[#143887]"
          />
        </div>
      </div>

      {/* Vehicle type for this route */}
      <div className="mt-3" style={{ position: "relative", zIndex: 21 }}>
        <label className="block text-xs font-medium mb-1.5 text-gray-600">
          Vehicle Type <span className="text-red-500">*</span>
        </label>
        <InlineSelect
          value={row.vehicle_type}
          options={vehicleTypeOptions}
          onChange={(val) => onChange(row.id, "vehicle_type", val)}
          placeholder="Select a vehicle type for this route"
        />
      </div>

      {/* Staff members for this route */}
      <div className="mt-3" style={{ position: "relative", zIndex: 20 }}>
        <label className="block text-xs font-medium mb-1.5 text-gray-600 flex items-center gap-1.5">
          Staff Members <span className="text-red-500">*</span>
          <InfoTooltip
            position="bottom"
            iconSize={12}
            title="Automatic order assignment"
            text="Only staff members assigned here become eligible to receive orders for this specific route. When a customer requests this route, any resulting order is automatically routed to one of the assigned staff member(s) — no manual dispatch needed."
          />
        </label>
        <InlineMultiSelect
          value={row.staff_member_ids}
          options={staffOptions}
          onChange={(vals) => onChange(row.id, "staff_member_ids", vals)}
          placeholder="Assign staff members with the Role of Driver to this route"
        />
      </div>
    </div>
  );
};

const uid = () => Math.random().toString(36).slice(2, 9);

const makeEmptyRoute = (): RouteRow => ({
  id: uid(),
  from: "",
  to: "",
  price: "",
  staff_member_ids: [],
  vehicle_type: "",
});

interface AddServiceModalProps {
  isModalOpen: boolean;
  setIsModalOpen: (param: boolean) => void;
  onSuccess?: () => void;
}

const AddServiceModal: React.FC<AddServiceModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  onSuccess,
}) => {
  const [form, setForm] = useState({
    service_category: "",
    description: "",
    price_model: "",
    vehicle_types: [] as string[],
    base_price: "",
    staff_members: [] as string[],
  });

  // Routes array — used for Local Relocation / state Relocation
  const [routes, setRoutes] = useState<RouteRow[]>([makeEmptyRoute()]);

  const { data: companyInfoData } = useGetCompanyInfoQuery();
  const companyId = companyInfoData?.data?.companyInfo?.id;

  const staffOptions = useStaffOptions();

  const { service_category, description, price_model, vehicle_types, base_price, staff_members } = form;

  const {
    data: serviceTypes,
    isLoading: loadingServiceTypes,
    isFetching: fetchingServiceTypes,
  } = useGetAllServiceTypesQuery(undefined, { skip: !isModalOpen });

  const isDynamicPricingId = serviceTypes?.find((type) => type.name === DAY_TO_DAY_SERVICE_NAME)?.id;
  const isRelocationIds = serviceTypes
    ?.filter((type) =>
      type.name === "Local Relocation" || type.name === "State Relocation"
    )
    .map((t) => t.id) ?? [];

  const isDispatch = service_category === isDynamicPricingId;
  const isRelocation = isRelocationIds.includes(service_category);
  // Shown as soon as they type a Day-to-Day base price under the minimum.
  const basePriceError = isDispatch && base_price !== "" ? dayToDayPriceError(base_price) : null;
  // Create stays disabled until a Day-to-Day base price meets the minimum (empty counts as not met).
  const basePriceBlocksCreate = isDispatch && !!dayToDayPriceError(base_price);

  const [createService, { isLoading: creatingService }] = useCreateServiceMutation();
  const { handlePlanLimitError } = usePlanLimit();
  const { hasPermission } = usePermission();

  const serviceCategoryOptions = useMemo(() =>
    serviceTypes?.map((type) => ({ label: type.name, value: type.id })) || [],
    [serviceTypes]
  );

  const vehicleTypeOptions = [
    { label: "Car", value: "car" },
    { label: "Truck", value: "truck" },
    { label: "Bike", value: "bike" },
    { label: "Van", value: "van" },
  ];

  const handleChange = (key: string, value: any) =>
    setForm((prev) => ({ ...prev, [key]: value }));

  const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    handleChange("base_price", e.target.value.replace(/[^0-9.]/g, ""));

  useEffect(() => {
    if (!service_category) {
      handleChange("price_model", "");
      return;
    }
    const derivedModel = isDispatch ? "dynamic" : "fixed";
    handleChange("price_model", derivedModel);
  }, [service_category, isDispatch]);

  useEffect(() => {
    if (isRelocation) {
      setRoutes([makeEmptyRoute()]);
    }
  }, [isRelocation]);

  const handleRouteChange = (id: string, field: keyof Omit<RouteRow, "id">, value: string | string[]) => {
    setRoutes((prev) =>
      prev.map((r) => (r.id === id ? { ...r, [field]: value } : r))
    );
  };

  const addRoute = () => setRoutes((prev) => [...prev, makeEmptyRoute()]);

  const removeRoute = (id: string) =>
    setRoutes((prev) => prev.filter((r) => r.id !== id));

  const resetForm = () => {
    setForm({
      service_category: "",
      description: "",
      price_model: "",
      vehicle_types: [],
      base_price: "",
      staff_members: [],
    });
    setRoutes([makeEmptyRoute()]);
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!hasPermission("add services")) {
      toast.error("You don't have permission to create a service");
      return;
    }
    if (!service_category) {
      toast.error("Please select a service category");
      return;
    }
    if (!description.trim()) {
      toast.error("Please enter a description");
      return;
    }
    if (!isRelocation && vehicle_types.length === 0) {
      toast.error("Please select at least one vehicle type");
      return;
    }

    if (isRelocation) {
      for (let i = 0; i < routes.length; i++) {
        const r = routes[i];
        if (!r.from.trim()) {
          toast.error(`Route ${i + 1}: Please enter the starting location`);
          return;
        }
        if (!r.to.trim()) {
          toast.error(`Route ${i + 1}: Please enter the destination`);
          return;
        }
        if (r.staff_member_ids.length === 0) {
          toast.error(`Route ${i + 1}: at least one staff member must be assigned.`);
          return;
        }
        if (!r.vehicle_type) {
          toast.error(`Route ${i + 1}: a vehicle type must be assigned.`);
          return;
        }
        if (!r.price || parseFloat(r.price) <= 0) {
          toast.error(`Route ${i + 1}: Please enter a valid price`);
          return;
        }
      }
    } else {
      if (!base_price || parseFloat(base_price) <= 0) {
        toast.error("Please enter a valid price");
        return;
      }
      if (isDispatch) {
        const minError = dayToDayPriceError(base_price);
        if (minError) {
          toast.error(minError);
          return;
        }
      }
    }

    try {
      let payload: any;

      if (isRelocation) {
        payload = {
          description,
          vehicle_type: routes[0]?.vehicle_type || "",
          price_model,
          service_type_id: service_category,
          company_id: companyId,
          staff_members_id: Array.from(
            new Set(routes.flatMap((r) => r.staff_member_ids))
          ),
          routes: routes.map((r) => ({
            from: r.from.trim(),
            to: r.to.trim(),
            price: parseFloat(r.price),
            staff_member_ids: r.staff_member_ids,
            vehicle_type: r.vehicle_type,
          })),
        };
      } else {
        payload = {
          description,
          base_price,
          vehicle_type: vehicle_types.join(", "),
          price_model,
          service_type_id: service_category,
          company_id: companyId,
          staff_members_id: staff_members,
        };
      }

      await createService(payload).unwrap();
      toast.success("Service created successfully!");
      resetForm();
      setIsModalOpen(false);
      if (onSuccess) onSuccess();
    } catch (error: any) {
      console.error("Create service error:", error);
      if (handlePlanLimitError(error)) return;
      toast.error(error?.data?.message || "Failed to create service");
    }
  };

  const handleClose = () => { resetForm(); setIsModalOpen(false); };

  return (
    <FleetrifyModal
      isOpen={isModalOpen}
      onClose={handleClose}
      title="Add Service"
      className="w-[90%] sm:w-[600px] md:w-[720px] h-auto max-w-full max-h-[90vh] overflow-y-auto"
      enableOutsideClick={false}
    >
      <div style={{ overflowY: "visible" }}>
        <form
          className="flex flex-col px-4 sm:px-8 md:px-12 lg:px-16 py-4"
          onSubmit={onSubmit}
          style={{ overflowY: "visible" }}
        >
          <div className="flex gap-3 items-center mb-6">
            <div className="bg-[#14388733] h-[24px] w-[24px] rounded-[3px] grid place-items-center">
              <figure>{fleetrifyIcons.addNewUserIcon}</figure>
            </div>
            <h6 className="text-sm font-bold text-[#00032A]">Add new Service Row</h6>
          </div>

          {/* Service Category */}
          <div className="flex flex-col md:flex-row md:gap-4 gap-4 w-full mb-4">
            <div className="flex-1 w-full" style={{ position: "relative", zIndex: 40 }}>
              <label className="block text-sm font-medium mb-2 text-gray-700">
                Service Category <span className="text-red-500">*</span>
              </label>
              <InlineSelect
                value={service_category}
                options={serviceCategoryOptions}
                onChange={(val) => handleChange("service_category", val)}
                placeholder={loadingServiceTypes || fetchingServiceTypes ? "Loading..." : "Select service category"}
                disabled={loadingServiceTypes || fetchingServiceTypes}
              />
            </div>
          </div>

          {/* One-per-category banner */}
          {service_category && (
            <div className="w-full mb-4 flex items-start gap-2.5 bg-amber-50 border border-amber-200 rounded-lg px-4 py-3">
              <svg className="flex-shrink-0 mt-0.5 text-amber-500" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 8 5Zm0 6.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" fill="currentColor"/>
              </svg>
              <p className="text-xs text-amber-700 leading-relaxed">
                <span className="font-semibold">One service per type.</span> You are only allowed to create one{" "}
                <span className="font-medium">State Relocation</span>,{" "}
                one <span className="font-medium">Local Relocation</span>, and{" "}
                one <span className="font-medium">Day-to-Day Delivery</span> service. Creating a duplicate will be rejected.
              </p>
            </div>
          )}

          {/* Description */}
          <div className="w-full mb-4">
            <FleetrifyTextareaField
              label="Description"
              id="description"
              value={description}
              onChange={(e) => handleChange("description", e.target.value)}
              placeholder="Enter service description"
              required
              className="w-full"
              textareaClassName="h-[65px]"
            />
          </div>

          {/* ── RELOCATION: single route row ── */}
          {isRelocation && (
            <div className="w-full mb-4" style={{ position: "relative", zIndex: 36 }}>
              <label className="text-sm font-medium text-gray-700 mb-3 flex items-center gap-1.5">
                Route <span className="text-red-500">*</span>
                <span className="text-xs font-normal text-gray-400">
                  (From → To with fixed price)
                </span>
                <InfoTooltip
                  position="bottom"
                  title="What is a route?"
                  text={`A route is a fixed origin ("From") and destination ("To") pair with its own price. Customers requesting this service can only book between the From/To combinations you define here. Add multiple routes to cover different origin-destination pairs under the same service.`}
                />
              </label>

              {routes.map((row, index) => (
                <RouteRowInput
                  key={row.id}
                  row={row}
                  index={index}
                  total={routes.length}
                  onChange={handleRouteChange}
                  onRemove={removeRoute}
                  staffOptions={staffOptions}
                  vehicleTypeOptions={vehicleTypeOptions}
                />
              ))}

              <button
                type="button"
                onClick={addRoute}
                className="flex items-center gap-2 text-sm text-[#143887] font-medium hover:text-[#0f2a66] transition-colors mt-1 mb-2"
              >
                <div className="w-6 h-6 rounded-full border border-[#143887] flex items-center justify-center">
                  <Plus size={13} />
                </div>
                Add another route
              </button>
            </div>
          )}

          {/* Price / Price Model — shown only for dispatch or other non-relocation */}
          {!isRelocation && (
            <div className="flex flex-col md:flex-row md:gap-4 gap-4 w-full mb-4">
              {/* Price Field */}
              <div className="flex-1 w-full">
                <label className="block text-sm font-medium mb-2 text-gray-700 flex items-center gap-1.5">
                  Dynamic Pricing <span className="text-red-500">*</span>
                  <InfoTooltip
                    position="bottom"
                    text={
                      isDispatch
                        ? `Minimum ${formatNaira(DAY_TO_DAY_MIN_BASE_PRICE)} - Maximum ₦20,000. This is the base/starting price, not the final charge. The final amount may increase depending on delivery distance, route conditions, and other operational factors. Trips under 5km don't use your base fare — they're priced by distance only, so short local deliveries stay affordable.`
                        : "Minimum ₦500 - Maximum ₦20,000. This is the base/starting price, not the final charge. The final amount may increase depending on delivery distance, route conditions, and other operational factors."
                    }
                  />
                </label>
                <div className="relative">
                  <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-600 font-semibold text-base">
                    ₦
                  </span>
                  <input
                    type="number"
                    value={base_price}
                    onChange={handlePriceChange}
                    placeholder={isDispatch ? `${DAY_TO_DAY_MIN_BASE_PRICE.toLocaleString("en-NG")}.00` : "0.00"}
                    max={20000}
                    min={isDispatch ? DAY_TO_DAY_MIN_BASE_PRICE : 500}
                    required
                    aria-invalid={!!basePriceError}
                    aria-describedby={isDispatch ? "base-price-hint" : undefined}
                    className={`w-full pl-10 pr-4 py-3 border rounded-md bg-[#FAFAFA] text-sm transition-colors duration-200 focus:outline-none focus:ring-[0.5px] ${
                      basePriceError
                        ? "border-red-500 focus:ring-red-500 focus:border-red-500"
                        : "border-gray-300 focus:ring-[#143887] focus:border-[#143887] hover:border-[#143887]"
                    }`}
                  />
                </div>
                {isDispatch && (
                  <p id="base-price-hint" className={`mt-1.5 text-xs ${basePriceError ? "text-red-600 font-medium" : "text-gray-500"}`}>
                    {basePriceError ?? `Minimum ${formatNaira(DAY_TO_DAY_MIN_BASE_PRICE)} for Day-to-Day Delivery.`}
                  </p>
                )}
              
               {/* <p className="mt-2 text-xs text-[#143887] hidden group-hover:block">
                  This amount serves as the base price. Final pricing may increase depending
                  on delivery distance, route conditions, and operational factors.
                </p> */}
              </div>

              {/* Price Model */}
              <div className="flex-1 w-full" style={{ position: "relative", zIndex: 35 }}>
                <label className="block text-sm font-medium mb-2 text-gray-700 flex items-center gap-1.5">
                  Price Model <span className="text-red-500">*</span>
                  <InfoTooltip
                    position="bottom"
                    text="Set automatically based on the service category — Dynamic for Day-to-Day Delivery, Fixed for Relocation services. It can't be edited directly."
                  />
                </label>
                <input
                  type="text"
                  value="Dynamic"
                  readOnly
                  disabled
                  required
                  className="w-full p-4 py-3 border border-gray-300 rounded-md bg-gray-50 text-sm cursor-not-allowed select-none"
                />
              </div>
            </div>
          )}

          {/* Price Model display for relocation (read-only info) */}
          {isRelocation && (
            <div className="w-full mb-4">
              <label className="block text-sm font-medium mb-2 text-gray-700">
                Price Model
              </label>
              <input
                type="text"
                value="Fixed (per route)"
                readOnly
                disabled
                className="w-full p-4 py-3 border border-gray-300 rounded-md bg-gray-50 text-sm cursor-not-allowed select-none"
              />
            </div>
          )}

          {/* Vehicle Types — for relocation, vehicle types are selected per-route instead */}
          {!isRelocation && (
            <div className="flex flex-col w-full mb-4" style={{ position: "relative", zIndex: 30 }}>
              <label className="text-sm font-medium mb-2 text-gray-700 flex items-center gap-1.5">
                Vehicle Types <span className="text-red-500">*</span>
                <InfoTooltip
                  position="bottom"
                  text="Customers can request this service with any of the vehicle types selected here. Orders are only matched to drivers with a matching vehicle type."
                />
              </label>
              <InlineMultiSelect
                value={vehicle_types}
                options={vehicleTypeOptions}
                onChange={(vals) => handleChange("vehicle_types", vals)}
                placeholder="Select vehicle types"
              />
            </div>
          )}

          {/* Staff Members — for relocation, staff is assigned per-route instead */}
          {!isRelocation && (
            <div className="flex flex-col w-full mb-4" style={{ position: "relative", zIndex: 25 }}>
              <label className="text-sm font-medium mb-2 text-gray-700 flex items-center gap-1.5">
                Staff Members <span className="text-red-500">*</span>
                <InfoTooltip
                  position="bottom"
                  title="Automatic order assignment"
                  text="Every staff member assigned here becomes eligible to receive orders for this service. When a customer requests this service, any resulting order is automatically routed to the assigned staff member(s) — no manual dispatch needed."
                />
              </label>

              <InlineMultiSelect
                value={staff_members}
                options={staffOptions}
                onChange={(vals) => handleChange("staff_members", vals)}
                placeholder="Assign staff members With the Role of Driver to this service"
              />
            </div>
          )}

          <div className="mt-6">
            <FleetrifyButton
              type="submit"
              className="w-full"
              disabled={creatingService || !hasPermission("add services") || basePriceBlocksCreate}
              title={basePriceBlocksCreate ? `Enter a base price of at least ${formatNaira(DAY_TO_DAY_MIN_BASE_PRICE)} to continue` : undefined}
            >
              {creatingService ? "Creating..." : "Create Service"}
            </FleetrifyButton>
          </div>
        </form>
      </div>
    </FleetrifyModal>
  );
};

export default AddServiceModal;